<!--正式授权申请-->
<template>

</template>

<script>
  export default {
    name: 'PermRequest'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/PermRequest.vue